<script>
  import { push } from "svelte-spa-router"
  import bulkUploadOperations, { updateLocalStorage } from "../../Stores/uploadFlow"
  import Row from "./Components/Row.svelte"
  /**
   * @type {Number} indicates the active parent row
   */
  let active = 0
</script>

<div class="w-full select-none rounded-md bg-white p-6 dark:bg-mdGray mobile:p-12 xls:text-justify">
  <!-- <div class="mx-auto w-full md:w-4/5 lg:w-3/5"> -->
  <!-- </div> -->
  <div class="w-full text-3xl font-bold dark:text-white md:text-5xl">Invalid Cells Found</div>
  <div class="mt-6 w-full sm:w-1/2">
    <div class="break-words text-justify text-sm text-gray-500 mobile:text-base">We have identified some invalid cells in your uploaded spreadsheet. The following details outline the specific errors, including row numbers and the type of each error detected.</div>
  </div>

  <div class="mt-6 flex w-full flex-col gap-3">
    {#each Object.keys($bulkUploadOperations.invalidObj) as parent, i}
      <Row {parent} index={i} bind:active />
    {/each}
  </div>
  <div class="flex w-full items-center pt-6">
    <button
      on:click={() => {
        $bulkUploadOperations.invalidObj = {}
        updateLocalStorage($bulkUploadOperations)
        push("/publish/bulk")
      }}
      type="button"
      class="flex h-9 w-9 min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-[#f7f7f7] px-2 text-sm font-medium text-gray-900 focus:outline-none dark:bg-lightgray dark:text-white dark:hover:bg-bodyblack md:w-32 lg:px-4"
    >
      <span>
        <i class="fa-solid fa-chevron-left" />
      </span>
      <span class="hidden select-none md:block">&nbsp;&nbsp;Previous&nbsp;</span>
    </button>
  </div>
</div>
